import React from "react";
import style from "./workingFile.module.scss";
import Header from "./Header";
import Footer from "./Footer";
import { dateFormateDD, formatAmountCalculate } from "../../utility";

function ITMain({ Content }) {
  return (
    <>
      <div className={style.invoiceContainer}>
        <div className={style.invoiceItems}>
          <table>
            <thead>
              <tr>
                <th>Description</th>
                <th>Qty</th>
                <th style={{ textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {/* <tr className={`${style.Recruitment}`}>
                <td
                  colSpan={2}
                  style={{
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  Recruitment charges
                </td>
              </tr> */}
              <tr>
                <td
                  style={{
                    // textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "13px",
                  }}
                >
                  IOT Application Software Module
                </td>
                <td
                  style={{
                    // textAlign: "left",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  1
                </td>
                <td
                  style={{
                    // textAlign: "left",

                    fontSize: "12px",
                  }}
                >
                  ₹1,00,000.00
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    // textAlign: "left",
                    fontSize: "13px",
                    fontWeight: "bold",
                  }}
                >
                  Laptop Rental Charges
                </td>
                <td
                  style={{
                    // textAlign: "left",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  1
                </td>
                <td
                  style={{
                    // textAlign: "left",
                    fontSize: "12px",
                  }}
                >
                  ₹10,000.00
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ITMain;
//  {`${item.name} ${
//                       item.employeeId ? "|" + item.employeeId : ""
//                     }   |  ${item.category}`}
//                     <div style={{ marginTop: "8px", fontWeight: "normal" }}>
//                       <span>Date of Joining: {dateFormateDD(item.joined)}</span>
//                     </div>
//                   </td>
//                   <td style={{ fontSize: "15px" }}>{item.ctc}</td>
